module.exports = __webpack_public_path__ + "img/douyu.409a0c50.png";